import React from "react";
import RequisitionsTooltip from "./components/RequisitionsTooltip";

interface IProps {
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const Requisitions = (props: IProps) => {
  return (
    <>
      <RequisitionsTooltip {...props} />
    </>
  );
};

export default Requisitions;
